











import { Ref, Prop, Vue, Component, Watch } from "vue-property-decorator";
import TokenField from "./tokenfield.vue";
import { TokenFieldValue, BulkTemplateFieldWithTokens } from '../model/frontend/BulkIssueTemplate';

@Component({
	components: {
        TokenField
    },
})
export default class BulkFieldWithTokens extends Vue {
	@Prop({ required: true }) public isNew!: boolean;
    @Prop({ required: false }) public type?: string;
    @Prop({ required: true }) public value!: BulkTemplateFieldWithTokens;
}
